import { Controller, useFormContext } from 'react-hook-form';
import CustomSwitch from '../../CustomSwitch/CustomSwitch';
import Typhography from '../../Typhography/Typhography';
import { BooleanField } from '../types';

const BooleanFieldForm = ({ field }: { field: BooleanField }) => {
  const { control, setValue, getValues } = useFormContext();
  return (
    <Controller
      name={field.key}
      control={control}
      render={({ field: renderField }) => (
        <div className="d-flex align-items-center gap-2">
          {field.label && <Typhography size="bold-14">{field.label}</Typhography>}
          <CustomSwitch
            value={!!renderField.value}
            onChange={(val) => {
              renderField.onChange(val);
              field.onAfterChange?.(val, { setValue, getValues });
            }}
          />
        </div>
      )}
    />
  );
};

export default BooleanFieldForm;
